module.exports = __webpack_public_path__ + "static/media/hero.116ae31f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/setlist/hero.png
// module id = 276
// module chunks = 0